import { AbstractControl, ValidationErrors, ValidatorFn } from '@angular/forms';

export function symptomsValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const values = control.value;
    return values &&
      (values.ear_pain == '1' ||
        values.headache == '1' ||
        values.falls == '1' ||
        values.seasickness == '1' ||
        values.joint_pain == '1' ||
        values.skin_spots == '1' ||
        values.nausea == '1' ||
        values.limbs_numbness == '1' ||
        values.extreme_fatigue == '1' ||
        values.vertigo == '1' ||
        values.limbs_tingling == '1' ||
        values.semi_drowning == '1')
      ? null
      : { symptomsSelected: true };
  };
}

export function divingWithValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const values = control.value;
    return values &&
      (values.diving_air == '1' ||
        values.diving_nitrox == '1' ||
        values.diving_trimix == '1' ||
        values.diving_rebreather == '1')
      ? null
      : { divingWithSelected: true };
  };
}

export function divingTypeValidator(): ValidatorFn {
  return (control: AbstractControl): ValidationErrors | null => {
    const values = control.value;
    return values &&
      (values.diving_type_first_dive == '1' ||
        values.diving_type_successive == '1')
      ? null
      : { divingTypeSelected: true };
  };
}
